module.exports = __webpack_public_path__ + "static/media/6106.68cfb79c.jpg";